import React from 'react'
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
// import Footer from "../../components/footer";
import CreateProfileContent from "./content/createprofilecontent"


const accountdetails = () => {
  return (
    <section>
      <div className="main ">
        <Header />
        <InnerHeader title="create profile " />
         <CreateProfileContent />
        {/* <Footer /> */}
      </div>
    </section>
  )
}

export default accountdetails